import { AppSettings } from '../../../settings';
import { Component, OnInit, Input } from '@angular/core';
import { AverageTrafficSummary } from '../average-traffic.model';

@Component({
  // tslint:disable-next-line:component-selector
  selector: '[app-average-traffic-item]',
  templateUrl: './average-traffic-item.component.html',
  styleUrls: ['./average-traffic-item.component.scss']
})
export class AverageTrafficItemComponent implements OnInit {
  @Input() summary: AverageTrafficSummary;

  currencySuffix: string;
  constructor(
    private _settings: AppSettings
  ) {
    this.currencySuffix = _settings.getCurrencySuffix(new Date());
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/average-traffic/average-traffic-item/average-traffic-item.component.ts